import * as React from "react";
import { Helmet } from "react-helmet";
import { IMetadata } from "../../../shared/interface/metadata";
import metaContent from "../cms/meta.json";

export interface IHeadProps {
  metadata?: IMetadata;
}

const headElementSelectors = [
  "meta[name='description']",
  "link[rel='canonical']",
  "meta[property='og:title']",
  "meta[property='og:url']",
  "meta[property='og:description']",
  "title",
];

// adds data attributes to elements from outside our app
// so that helmet can modify them.  Helmet will add duplicate
// attributes if they do not have data-react-helmet="true" on them.  Pretty
// lame ...
const helmetify = (selector: string) =>
  document.querySelector(selector)?.setAttribute("data-react-helmet", "true");

export class Head extends React.Component<IHeadProps> {
  constructor(props) {
    super(props);

    headElementSelectors.map(helmetify);
  }

  render() {
    const metadata = this.props.metadata;
    const metaTitle = metadata?.title
      ? `${metadata?.title}${metaContent.titleSuffix}`
      : metaContent.defaultTitle;
    const metaDescription =
      metadata?.description || metaContent.defaultDescription;
    const canonicalUrl =
      metadata?.canonicalUrl ||
      window.location.origin + window.location.pathname;
    return (
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
      </Helmet>
    );
  }
}
